import { Component, ElementRef, Injector, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { FichaDespesaService } from 'administrativo-lib';
import { BaseResourceFormComponent, Credito, CreditoItem, DateFormatPipe, FuncaoService, GlobalService, LoginContabil } from 'eddydata-lib';
import { MessageService } from 'primeng/api';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { CreditoItemService } from '../service/credito-item.service';
import { CreditoService } from '../service/credito.service';

@Component({
  selector: 'app-credito-form',
  templateUrl: './credito-form.component.html'
})
export class CreditoFormComponent extends BaseResourceFormComponent<Credito, LoginContabil> {

  /**
   * Declaração de variáveis
   */
  @ViewChild('myInput') inputField: ElementRef;

  public listaTipos: Array<any>;
  public listaOcorrencias: Array<any>;
  public listaCreditoItens: Array<CreditoItem>;
  public totalEmpenhado: number;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    private messageService: MessageService,
    protected injector: Injector,
    protected globalService: GlobalService,
    protected funcaoService: FuncaoService,
    protected fichaService: FichaDespesaService,
    protected creditoItemService: CreditoItemService,
    protected creditoService: CreditoService) {
    super(new Credito(), injector, Credito.converteJson, creditoService);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      data_credito: [null, [Validators.required]],
      data_publicacao: [null, [Validators.required]],
      data_vigencia: [null, [Validators.required]],
      mes: [null],
      tipo: [null, [Validators.required]],
      ocorrencia: [null, [Validators.required]],
      decreto: [null, [Validators.required]],
      lei: [null, [Validators.required]],
      justificativa: [null, [Validators.required]],
      orgao: [this.login.orgao, [Validators.required]],
      exercicio: [this.login.exercicio, [Validators.required]],
      itens: [[]],
      creditoItens: [[]]
    });
  }

  protected afterLoad() {
    this.entidade.data_credito = new DateFormatPipe().transform(this.entidade.data_credito, []);
    this.entidade.data_publicacao = new DateFormatPipe().transform(this.entidade.data_publicacao, []);
    this.entidade.data_vigencia = new DateFormatPipe().transform(this.entidade.data_vigencia, []);
    this.totalEmpenhado = 0;
    this.creditoItemService.obterPorCredito(this.entidade.id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((dados) => {
        this.listaCreditoItens = dados ? dados.content : new Array<CreditoItem>();
        for (const item of this.listaCreditoItens) {
          this.fichaService.totalizadores(this.entidade.exercicio.id, this.login.orgao.id, item.ficha.id).toPromise().then(
            (res) => {
              if (res.content.length) {
                item.empenhado = +res.content[0].total_empenhado;
                item.dotacao = (+res.content[0].valor_orcado + +res.content[0].total_creditado)
                  - (+res.content[0].total_reservado + +res.content[0].total_empenhado);
                this.totalEmpenhado += item.empenhado;
              } else {
                item.empenhado = 0;
                this.totalEmpenhado = 0;
              }
            }
          );
        }
      }, error => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: error })
      );
  }

  protected parametrosExtras(): {} {
    return {
      relations:
        'exercicio,orgao,itens.ficha.despesa,itens.ficha.funcao,itens.ficha.subfuncao,itens.ficha.acao,itens.ficha.programa'
    };
  }

  protected afterInit(): void {
    this.listaTipos = this.globalService.obterListaTiposCreditos();
    this.listaOcorrencias = this.globalService.obterListaOcorrenciasCreditos();
    if (this.currentActionRoute === 'novo') {
      this.listaCreditoItens = new Array<CreditoItem>();
    }
  }

  protected campoFoco(): ElementRef {
    return this.inputField;
  }

  protected beforeSubmit() {
    try {
      if (this.entidadeForm.get('data_credito').value === null) {
        throw new Error('É necessário informar a data do crédito');
      }
      if (this.entidadeForm.get('ocorrencia').value === null) {
        throw new Error('É necessário informar a ocorrência para o crédito');
      }
      if (this.entidadeForm.get('tipo').value === null) {
        throw new Error('É necessário informar o tipo de crédito');
      }
      if (this.totalEmpenhado > 0) {
        const dt1 = new Date(new DateFormatPipe().transform(this.entidadeForm.get('data_credito').value, []));
        const dt2 = new Date(this.entidade.data_credito);
        if (dt1.toISOString().slice(0, 10) !== dt2.toISOString().slice(0, 10)) {
          throw new Error('Não é possível alterar a data do crédito, pois já existem fichas empenhadas');
        }
      }
      console.log(this.listaCreditoItens);
      this.entidadeForm.get('creditoItens').setValue(this.listaCreditoItens);
      const dataCredito = new DateFormatPipe().transform(this.entidadeForm.get('data_credito').value, []);
      this.entidadeForm.get('mes').setValue(dataCredito.getUTCMonth() + 1);
    } catch (e) {
      toastr.warning(e);
      throw e;
    }

  }

  protected afterSubmit(ent: Credito) {
    this.listaCreditoItens = new Array<CreditoItem>();
  }


  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  public voltar() {
    switch (this.login.sistema) {
      case 'contabil':
        this.router.navigate(['/planejamento']);
        break;
      default:
        this.sair();
        break;
    }
  }

}
